/*
 * 游戏的展示模式
 */
export enum FrameMode {
  /* 全屏展示 */
  FULL_SCREEN = "fullScreen",
  FULL_SCREEN_WITH_CONTROL = "fullScreenWithControl",
  /* 上方展示游戏界面，下方展示面板 */
  WITH_PANEL = "withPanel",
}
